import newTheme from 'themes/theme';

export default {
  wrapper: {
    backgroundColor: newTheme.palette.primary.light,
  },
  main: {
    padding: '20px 75px',
    borderBottom: 'solid 1px lightgray',
    textTransform: 'uppercase',

    '@media screen and (max-width: 600px)': {
      padding: '20px 16px',
    },
  },
  terms: {
    margin: '8px 0',
    fontSize: '12px',
    fontWeight: '600',
    textAlign: 'justify',

    '@media screen and (max-width: 600px)': {
      textAlign: 'left',
    },
  },
};
